$(document).on("turbo:load", function () {
  $(".new-users-alert .icon-remove").on("click", function () {
    $(".new-users-alert").hide()
    return
  })
})
